<ngx-charts-bubble-chart [customColors]="colors" [results]="series" [scheme]="scheme" [view]="[992,8+48*series.length]"
  [xAxisTickFormatting]="format" [yScaleMin]="0" xmlns="http://www.w3.org/1999/html">
  <ng-template #tooltipTemplate let-model="model">
    {{model.x | datestamp}}<span *ngIf="model.r >= 1"> {{model.r}} x {{model.series}}</span><br>
    <span *ngFor="let timestamp of model.timestamps">{{timestamp}}<br></span>
  </ng-template>
</ngx-charts-bubble-chart>
